import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';

import { Logger } from './../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McLisTestService {

  constructor(
    private sdk: MycureSDK,
  ) { 

  }

  loadLabTests(organization: string) {
    const query = { facility: organization };
    return this.sdk.lis.tests().find(query);
  }

  loadLabTest(id: string) {
    return this.sdk.lis.tests().get(id);
  }

  loadLabTestMeasures(id: string) {
    const query: any = { test: id };
    return this.sdk.lis.measures().find(query);
  }

  createLabTest(data: any) {
    const values = _.pick(data, ['name', 'description', 'section', 'facility', 'hl7IdentifierCod', 'hl7IdentifierSys']);
    return this.sdk.lis.tests().create(values);
  }

  updateLabTest(id: string, data: any) {
    const values = _.pick(data, ['name', 'description', 'section', 'hl7IdentifierCod', 'hl7IdentifierSys']);
    return this.sdk.lis.tests().update(id, values);
  }

  removeLabTest(id: string) {
    return this.sdk.lis.tests().remove(id);
  }
}
